var u = navigator.userAgent;
var app = navigator.appVersion;
/**
 * IE内核
 */
var trident = u.indexOf("Trident") > -1;
/**
 * opera内核
 */
var presto = u.indexOf("Presto") > -1;
/**
 * 苹果、谷歌内核
 */
var webKit = u.indexOf("AppleWebKit") > -1;
/**
 * 火狐内核
 */
var gecko = u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1;
/**
 * 是否为移动终端
 */
var mobile = !!u.match(/AppleWebKit.*Mobile.*/);
/**
 * ios终端
 */
var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
/**
 * android终端
 */
var android = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
/**
 * 是否为iPhone或者QQHD浏览器
 */
var iPhone = u.indexOf("iPhone") > -1;
/**
 * 是否iPad
 */
var iPad = u.indexOf("iPad") > -1;
/**
 * 是否web应该程序，没有头部与底部
 */
var webApp = u.indexOf("Safari") == -1;
/**
 * 是否微信
 */
var weixin = u.indexOf("MicroMessenger") > -1;
/**
 * 是否QQ
 */
var qq = u.match(/\sQQ/i);
/**
 * 华为
 */
var huawei = /huawei/i.test(u);
/**
 * 荣耀
 */
var honor = /honor|pct-al|clt-|lya-/i.test(u);
/**
 * oppo
 */
var oppo = /oppo/i.test(u);
/**
 * oppoR15
 */
var oppoR15 = /pacm00|PACT|PAAT|cph\d{1,}/i.test(u);
var language = navigator.language.toLowerCase();
export { app, trident, presto, webKit, gecko, mobile, ios, android, iPhone, iPad, webApp, weixin, qq, huawei, honor, oppo, oppoR15, language, };
export function isSupportWebp() {
    try {
        return (document
            .createElement("canvas")
            .toDataURL("image/webp", 0.5)
            .indexOf("data:image/webp") === 0);
    }
    catch (err) {
        return false;
    }
}
export function isSupportCssVar() {
    return window.CSS && window.CSS.supports && window.CSS.supports("--a", "0");
}
